<template>
    <div>
        <div class="row" style="position: fixed !important; width: 100%">
            <div class="col s3 white height100" style="position: relative;" id="left-bar">
                <div id="steps-container">
                    <router-link to="/nova-circular">
                        <div class="step" :class="{ active: step === 1 }">
                            <span>1</span>
                        </div>
                    </router-link>

                    <div class="step" :class="{ active: step === 2 }">
                        <span>2</span>
                    </div>

                    <div class="step" :class="{ active: step === 3 }">
                        <span>3</span>
                    </div>
                </div>

                <img src="../../../assets/svg/ads-svgrepo-com.svg" class="responsive-img center-el" style="width: 40%; margin-top: 50%; " alt="">
                <h6 style="font-weight: bold; color: #8F9297;" class="center-align">{{ title }}</h6>
                <div class="row">
                    <div class="col s6 offset-s3">
                        <p class="center-align" style="font-weight: 200; color: #8F9297;">
                            {{ subtitle }}
                        </p>
                    </div>
                </div>

                <div class="row" style="position: absolute; bottom: 20px;">
                    <div class="col s7 offset-s3">
                        <p class="center-align" style="font-weight: 200; color: #8F9297;">
                            Problemas? Entre em contato clicando <a href="#">aqui</a>.
                        </p>
                    </div>
                </div>

            </div>
            <div class="col s9 white height100" style="overflow-y: scroll">
                <div class="container">
                    <div class="row" style="position: fixed; width: 100%; background-color: #fff; z-index: 9999">
                        <h3 style="font-weight: 300; color: #2F3F52;">
                            {{ pagetitle }}
                        </h3>
                    </div>

                    <div class="row" style="padding-top: 110px">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="fixed-action-btn">
            <a class="btn-floating btn-large teal">
                <i class="large material-icons">menu</i>
            </a>
            <ul>
                <li><a href="/" class="btn-floating blue-accent tooltipped" data-position="left" data-tooltip="Início"><i class="material-icons">home</i></a></li>
                <!-- <li><a hreclass="btn-floating blue darken-1 tooltipped" data-position="left" data-tooltip="Nova circular"><i class="material-icons">image</i></a></li> -->
                <!-- <li><a class="btn-floating blue-grey tooltipped" data-position="left" data-tooltip="Relatórios"><i class="material-icons">print</i></a></li> -->
                <li><a href="/logout" class="btn-floating red darken-2 tooltipped" data-position="left" data-tooltip="Sair do sistema"><i class="material-icons">exit_to_app</i></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'choice_template',
    props: [
        "title", "subtitle", "step", "pagetitle"
    ],
    mounted() {
        $(document).ready(function() {
            $('.fixed-action-btn').floatingActionButton();

            $('.tooltipped').tooltip();
        });
    }
}
</script>

<style lang="scss" scoped>
    .height100 {
            height: 100vh;
        }

        #left-bar {
            border-right: 2px solid #DEE4EA;
        }

        #steps-container {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 10%;
        }

        .step {
          width: 2.5em;
          height: 2.5em;
          text-align: center;
          line-height: 2.5em;
          position: relative;
          margin-bottom: 10px;
          float: left;
          margin-left: 5px;
        }

        .step span {
          position: relative;
          font-family: 'Helvetica Neue', Arial, sans-serif;
          font-weight: 200;
          font-size: 1.5em;
          color: #8F9297;
          z-index: 1000;
          white-space: nowrap;
        }

        .step.active span {
          color: #478FF1;
        }

        .step::before {
          position: absolute;
          left: 5%;
          top: 5%;
          height: 90%;
          width: 90%;
          background: white;
          content: '';
          z-index: 600;
          border-radius: 50%;
        }

        .step::after {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          background: #fff;
          content: '';
          z-index: 500;
          border-radius: 50%;
        }

        .step.active::after {
          background: #478FF1;
        }

        .center-el {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
</style>





// WEBPACK FOOTER //
// src/components/shared/base_circular_new/BaseCircularNew.vue